'use client'

import React, { useEffect, useId, useState } from "react"
import { useSearchParams, usePathname, useRouter } from "next/navigation"
import { changeFilters, toggleFilter } from "@/services/search"
import Dropdown from "@/components/form/Dropdown"

type SortProps = {

}

export default function Sort({}: SortProps) {

    const searchParams = useSearchParams()
    const pathname = usePathname()
    const { replace } = useRouter()  
    const [facets, setFacets] = useState({})  

    const [sort, setSort] = useState<string>('date:asc')

    useEffect(() => {
        setSort(searchParams.get('sort') ?? 'date:asc')
    }, [searchParams])

    return (
        <>
            <Dropdown
                className='mini'
                title=''
                value={sort}
                multiple={false}
                nullable={false}
                search={false}
                withLabel={false}
                options={{
                    'date:asc': 'Date',
                    'price:asc': 'Prix'                    
                }}
                onChange={(value) => {
                    setSort(value)
                    replace(`${pathname}?${changeFilters(searchParams, {sort: value}).toString()}`, {
                        scroll: false
                    })
                }}
            />                    
        </>
    )
}